import * as React from 'react';

export default function LocationSelect({...rest}) {
  return (
    <svg
      {...rest}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 11.4506H23L22.94 12.7806H20.94C20.6063 17.219 17.0784 20.747 12.64 21.0806V23.0806H11.3V21.0806C6.86158 20.747 3.33366 17.219 3 12.7806H1V11.4506H3C3.33083 6.99779 6.87638 3.46075 11.33 3.14062V1.14062H12.7V3.14062C17.1419 3.47492 20.6711 7.0083 21 11.4506ZM12.67 17.1106V19.7506C16.3659 19.419 19.2978 16.4955 19.64 12.8006H17V11.4706H19.7C19.3784 7.74596 16.4247 4.79221 12.7 4.47062V7.11063H11.36V4.45062C7.63533 4.77221 4.68159 7.72596 4.36 11.4506H7V12.7506H4.33C4.65159 16.4753 7.60533 19.429 11.33 19.7506V17.1106H12.67Z"
        fill="#001E50"
      />
    </svg>
  );
}
